let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lzR49")).then(() => parcelRequire('2JlxN'));